import { ref, computed, watch, resolveComponent, createElementBlock, openBlock, createElementVNode, createVNode, unref, withCtx } from "vue";
import { ROLES_LOOKUP } from "../../../graphql/queries.js";
import { CHANGE_USER_ROLES } from "../../../graphql/mutations.js";
import { cloneDeep } from "lodash-es";
import { difference } from "../../../utils/difference.js";
import { useApolloGlobalClient } from "../../../plugins/apollo.js";
import "../../../constants/UserPolicy.js";
import "pinia";
import "../../../store/index.js";
import { useI18n } from "../../../plugins/i18n.js";
import "../../../plugins/banza/img.js";
import "axios";
import "vue-router";
import "maska";
import "../../../graphql/subscriptions.js";
import "vuetify";
import "vue-social-sharing";
import "@duannx/vue-client-only";
import "vuetify/components/VSnackbar";
import "../../../assets/3448554beb4b633a.svg";
import "vuetify/components/VImg";
import "../../../constants/components/index.js";
/* empty css                            */
import "vuetify/components/VDialog";
import Swal from "sweetalert2";
import "@vee-validate/i18n";
/* empty css                           */
import { VCardActions } from "vuetify/components/VCard";
import "vuetify/components/VOverlay";
import "vuetify/components/VProgressCircular";
/* empty css                                     */
import { VDivider } from "vuetify/components/VDivider";
import "vuetify/components/VList";
import "../../../assets/8a32dc557a826bf0.png";
/* empty css                        */
import "../../../graphql/navigation-menu.js";
import "vuetify/components/VSkeletonLoader";
/* empty css                                    */
import "vuetify/components/VBtn";
import "vuetify/components/VNavigationDrawer";
import "vuetify/components/VMenu";
import "../../Auth/AppleAuthButton/AppleAuthButton.js";
import "../../Auth/FacebookAuthButton/FacebookAuthButton.js";
import "../../Auth/GoogleAuthButton/GoogleAuthButton.js";
import "../../Auth/InstagramAuthButton/InstagramAuthButton.js";
import "../../Auth/TelegramAuthButton/TelegramAuthButton.js";
import "vee-validate";
/* empty css                                  */
import { VSpacer } from "vuetify/components/VGrid";
import "../../Base/index.js";
import "moment";
import "vuex";
/* empty css                           */
import "vuetify/components/VIcon";
import "vuetify/components/VProgressLinear";
import "vuetify/components/transitions";
import "vue-virtual-scroller";
import "vue-virtual-scroller/dist/vue-virtual-scroller.css";
import "../../../icons/mdi/index.js";
/* empty css                               */
import "vuetify/components/VBtnToggle";
import "../../../assets/6f5dc1ff0a697731.svg";
import "../../../assets/888bb8db73be3c15.svg";
/* empty css                                */
import "vuetify/components/VInfiniteScroll";
/* empty css                                     */
/* empty css                         */
import "vuetify/components/VChip";
/* empty css                             */
import "../../HtmlEditor/index.js";
import "../../Messages/vue-advanced-chat/lib/RoomsList/RoomContent/RoomContent.vue.js";
import "../../Messages/vue-advanced-chat/lib/Room/Room.vue.js";
/* empty css                                                  */
/* empty css                           */
import "../../News/NewsModule/NewsModule.vue.js";
import "../../News/NewsModule/NewsList.vue.js";
import "../../../graphql/news.js";
/* empty css                           */
import "../../Pages/index.js";
import "vue3-runtime-template";
import "ckeditor5/ckeditor5.css";
/* empty css                                    */
import "vuetify/components/VWindow";
import "../../../assets/5a0af7dd23957928.png";
import "tiny-emitter/instance";
import "../../../graphql/system-settings.js";
/* empty css                                */
/* empty css                                       */
import "vuetify/components/VHover";
import "../../../constants/NewsGroup.js";
/* empty css                                        */
import "vuetify/components/VTabs";
import "vuetify/directives";
import "@iconify/vue";
import "mobile-device-detect";
/* empty css                                      */
import "vuetify/components/VBottomSheet";
import "../../../graphql/favorites.js";
import "../../../plugins/tracker/page-tracker.js";
/* empty css                                */
import "../../../graphql/notifications.js";
/* empty css                                     */
import "../../../constants/CommunicationChannels.js";
/* empty css                               */
import "vuetify/components/VColorPicker";
/* empty css                                                   */
import "vuetify/components/VTextarea";
/* empty css                               */
import "vuetify/components/VTooltip";
/* empty css                                                */
/* empty css                             */
import "graphql-tag";
import "../../../graphql/lookups.js";
import "../../../graphql/entity.js";
/* empty css                          */
import "vuetify/components";
/* empty css                                */
/* empty css                        */
import "../../../graphql/system-events.js";
/* empty css                                           */
/* empty css                            */
/* empty css                            */
import "vuetify/components/VCombobox";
import "vuetify/components/VExpansionPanel";
import "vuetify/components/VTable";
import "../../../graphql/files.js";
import "vuetify/components/VForm";
/* empty css              */
/* empty css                            */
import "vuetify/components/VAlert";
/* empty css                 */
import "vue-dndrop";
/* empty css                                               */
/* empty css                                       */
import "vue-advanced-cropper";
import "../../../assets/e94e4817134d7c25.png";
import "vue-advanced-cropper/dist/style.css";
/* empty css                           */
import "vuetify/components/VFileInput";
/* empty css                               */
import "vuetify/components/VAvatar";
/* empty css                                     */
import "vuetify/components/VTextField";
import "vuetify/components/VTimeline";
/* empty css                                 */
import "../../../graphql/public-articles.js";
/* empty css                                              */
/* empty css                                  */
import "vuetify/components/VChipGroup";
import "vuetify/components/VSelect";
import "vuetify/components/VSheet";
/* empty css                                     */
import "vuetify/components/VItemGroup";
/* empty css                                */
import "vuetify/components/VCheckbox";
import "vuetify/components/VRadio";
import "vuetify/components/VRadioGroup";
import "cronstrue/i18n";
import "cron-parser";
/* empty css                           */
import "../../../graphql/quartz.js";
import "vue-i18n";
import "../../../graphql/integration-systems.js";
import "../../../constants/IntegrationSystemLogDirection.js";
/* empty css                                                         */
/* empty css                                       */
import "../../../graphql/session-store.js";
import "../../../composables/useModalPage.js";
import "../../../icons/portal/index.js";
const _hoisted_1 = ["colspan"];
const _sfc_main = {
  __name: "UsersSectionExpandedRow",
  props: {
    rowData: Object,
    colspan: {
      type: Number,
      default: 1
    }
  },
  emits: ["close"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const { t } = useI18n();
    const client = useApolloGlobalClient();
    const editedItem = ref(cloneDeep(props.rowData));
    const roles = computed({
      get() {
        var _a, _b, _c, _d;
        return ((_d = (_c = (_b = (_a = editedItem.value) == null ? void 0 : _a.user) == null ? void 0 : _b.roles) == null ? void 0 : _c.filter((c) => !c.isDeleted)) == null ? void 0 : _d.map((c) => {
          return {
            id: c.id,
            name: c.name
          };
        })) || [];
      },
      set(val) {
        var _a, _b;
        let objValue = ((_b = (_a = editedItem.value) == null ? void 0 : _a.user) == null ? void 0 : _b.roles) || [];
        if (objValue.length > 0) {
          const filteredValues = objValue.filter(
            (c) => c.id || !!val.find((cat) => (cat.name || cat) === c.name)
          );
          if (filteredValues.length < objValue.length) {
            objValue = filteredValues;
          }
          objValue.forEach((c) => {
            c.isDeleted = !val.find((cat) => cat.id === c.id);
          });
        }
        val.forEach((c) => {
          if (!objValue.find(
            (cat) => c.id && cat.id === c.id || (c.name || c) === cat.name
          )) {
            objValue.push({
              id: c.id,
              name: c.name || c,
              isDeleted: false
            });
          }
        });
        editedItem.value.user.roles = objValue;
      }
    });
    const newRoles = computed(() => {
      var _a, _b, _c;
      return ((_c = (_b = (_a = editedItem.value) == null ? void 0 : _a.user) == null ? void 0 : _b.roles) == null ? void 0 : _c.filter(
        (x) => {
          var _a2, _b2, _c2;
          return !x.isDeleted && !((_c2 = (_b2 = (_a2 = props.rowData) == null ? void 0 : _a2.user) == null ? void 0 : _b2.roles) == null ? void 0 : _c2.some((r) => r.id === x.id));
        }
      )) || [];
    });
    const deletedRoles = computed(() => {
      var _a, _b, _c;
      return ((_c = (_b = (_a = editedItem.value) == null ? void 0 : _a.user) == null ? void 0 : _b.roles) == null ? void 0 : _c.filter(
        (x) => {
          var _a2, _b2, _c2;
          return !((_c2 = (_b2 = (_a2 = editedItem.value) == null ? void 0 : _a2.user) == null ? void 0 : _b2.roles) == null ? void 0 : _c2.some(
            (r) => r.id === x.id && !r.isDeleted
          ));
        }
      )) || [];
    });
    const close = () => {
      emit("close");
    };
    const saveEditable = async () => {
      var _a;
      let text = `${t("components.users.messages.role_changing")} ${editedItem.value.name}?`;
      if (newRoles.value.length > 0) {
        text += `<br>${t("components.users.messages.role_new")} ${newRoles.value.map((r) => r.name).join(", ")}.`;
      }
      if (deletedRoles.value.length > 0) {
        text += `<br>${t(
          "components.users.messages.role_delete"
        )} ${deletedRoles.value.map((r) => r.name).join(", ")}.`;
      }
      const result = await Swal.fire({
        title: text,
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: t("base.yes"),
        cancelButtonText: t("base.buttons.cancel")
      });
      if (!result.isConfirmed) {
        close();
        return;
      }
      const changedData = difference(editedItem.value.user, props.rowData.user);
      if (!((_a = changedData.roles) == null ? void 0 : _a.length)) {
        return;
      }
      await client.mutate({
        mutation: CHANGE_USER_ROLES,
        variables: {
          userId: editedItem.value.user.id,
          roles: changedData.roles
        }
      });
      editedItem.value.user.roles = editedItem.value.user.roles.filter(
        (r) => !r.isDeleted
      );
      Object.assign(props.rowData, cloneDeep(editedItem.value));
      close();
    };
    watch(
      () => props.rowData,
      (newValue) => {
        editedItem.value = cloneDeep(newValue);
      }
    );
    return (_ctx, _cache) => {
      const _component_b_autocomplete = resolveComponent("b-autocomplete");
      const _component_b_btn = resolveComponent("b-btn");
      return openBlock(), createElementBlock("tr", null, [
        createElementVNode("td", { colspan: __props.colspan }, [
          createVNode(_component_b_autocomplete, {
            modelValue: roles.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => roles.value = $event),
            label: _ctx.$t("base.labels.roles"),
            query: unref(ROLES_LOOKUP),
            "prepend-icon": "mdi-account-group",
            multiple: "",
            chips: "",
            "closable-chips": "",
            "select-mode": "",
            clearable: "",
            "items-result-path": "roles",
            color: "primary",
            class: "ma-3"
          }, null, 8, ["modelValue", "label", "query"]),
          createVNode(VDivider),
          createVNode(VCardActions, { class: "pa-3 g-2" }, {
            default: withCtx(() => [
              createVNode(VSpacer),
              createVNode(_component_b_btn, {
                onClick: saveEditable,
                preset: "save",
                disabled: !newRoles.value.length && !deletedRoles.value.length
              }, null, 8, ["disabled"]),
              createVNode(_component_b_btn, {
                onClick: close,
                preset: "cancel"
              })
            ]),
            _: 1
          })
        ], 8, _hoisted_1)
      ]);
    };
  }
};
export {
  _sfc_main as default
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
